import { render, staticRenderFns } from "./CmgAccountModalMenuLinks.vue?vue&type=template&id=2026712f&scoped=true&lang=pug&"
import script from "./cmg-account-modal-menu-links.ts?vue&type=script&lang=ts&"
export * from "./cmg-account-modal-menu-links.ts?vue&type=script&lang=ts&"
import style0 from "./CmgAccountModalMenuLinks.vue?vue&type=style&index=0&id=2026712f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2026712f",
  null
  
)

export default component.exports